import { useQuery } from 'react-query';

import { getPasswordPattern as queryFn } from 'api/endPoints/getPasswordPattern';

const useQueryPasswordPatternData = (params) => {
    return useQuery({
        queryKey: ['passwordPatternData', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params?.email),
    });
};

export { useQueryPasswordPatternData };
